import { useForm } from '@fukuri-admins/hooks/common';
import { zodResolver } from '@hookform/resolvers/zod';
import { useState } from 'react';
import { login } from '../../../api/sign_in';
import { UserInfo, useAuth } from '../../../components/auth/AuthProvider';
import { LoginFormFieldValues, loginSchema } from '../logics/schema';
import { IUseLoginModal } from '../types';

export const useLoginModal: IUseLoginModal = () => {
  const { signIn } = useAuth();
  const [errMsg, setErrMsg] = useState<string>('');

  const methods = useForm<LoginFormFieldValues>({
    defaultValues: {
      email: '',
      password: '',
      partnerCode: '',
    },
    criteriaMode: 'all',
    mode: 'onChange',
    resolver: zodResolver(loginSchema),
  });

  const handleSubmit = methods.handleSubmit(async ({ email, password, partnerCode }) => {
    try {
      const response = await login({
        client_admin_user: {
          email,
          password,
          code: partnerCode,
        },
      });
      const data = await response.json();
      const userInfo = data as UserInfo;
      userInfo.three_letter_code = partnerCode;
      signIn(userInfo);
    } catch {
      setErrMsg('ログインできませんでした。ネットワークの状態を確認し、もう一度お試しください。');
    }
  });

  const { isValid, isSubmitting } = methods.formState;
  const buttonDisabled = !isValid || isSubmitting;

  return {
    state: {
      methods,
      errMsg,
      buttonDisabled,
    },
    actions: {
      handleSubmit,
      setErrMsg,
    },
  };
};
